var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCongratulation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#00796B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0172 34.7045L37.9547 54.767C37.4859 55.2355 36.8502 55.4987 36.1875 55.4987C35.5247 55.4987 34.8891 55.2355 34.4203 54.767L23.2297 43.517C22.7616 43.0483 22.4988 42.413 22.4988 41.7506C22.4988 41.0882 22.7616 40.4529 23.2297 39.9842L26.3547 36.8592C26.8232 36.3926 27.4575 36.1307 28.1187 36.1307C28.7799 36.1307 29.4142 36.3926 29.8828 36.8592L36.25 43.0342L51.3687 28.1014C51.8373 27.6343 52.4719 27.3721 53.1336 27.3721C53.7952 27.3721 54.4298 27.6343 54.8984 28.1014L58.0156 31.1545C58.25 31.3868 58.4361 31.6632 58.5632 31.9678C58.6902 32.2724 58.7557 32.5992 58.7559 32.9292C58.756 33.2592 58.6908 33.586 58.564 33.8907C58.4372 34.1954 58.2514 34.472 58.0172 34.7045Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCongratulation);
export default __webpack_public_path__ + "static/media/icon-congratulation.f52418c15c2c5f323b9d31b2716d342a.svg";
export { ForwardRef as ReactComponent };